module.exports = __webpack_public_path__ + "img/dqpcdj.da0399eb.png";